import numeral from 'numeral';
import 'numeral/locales';

const vueNumeral = ({ locale = 'id' } = {}) => {

  // load a locale
  numeral.register('locale', 'id', {
    delimiters: {
      thousands: ',',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'rb',
      million: 'jt',
      billion: 'm',
      trillion: 't'
    },
    ordinal: function (_) {
      return '';
    },
    currency: {
      symbol: 'Rp'
    }
  });

  // switch between locales
  numeral.locale(locale);

  console.log('numeral installed');
};

export default vueNumeral;
